import React from 'react';
import { get, isEmpty, isFunction } from '../../Utils/helpers';
import { TestResultsAccordionHeader } from './TestResultsAccordionHeader';
import { UrlTestSuite } from './helpers/UrlTestSuite';
import { defaultType } from './helpers/defaultType';

const customOperationsByType = {
  UrlTestSuite,

  WCTestSuite: {
    getTypeText: () => 'CMP',
  },

  TestCase: {
    getTypeText: () => 'TC',
  },

  TestCaseStep: {
    getTypeText: () => 'Steps',
  },

  default: defaultType,
};

export const getData = (currentTestResult, fn, pType) => {
  const customFn = get(
    customOperationsByType,
    `${pType}.${fn}`,
    get(customOperationsByType, `default.${fn}`)
  );
  if (isFunction(customFn)) {
    return customFn(currentTestResult);
  }
};

function transformTestResultsForTreeView(
  tr,
  trIndex = 0,
  parentsIds = [],
  typeName = 'UrlTestSuite'
) {
  const type = get(tr, 'type', typeName);
  const children = getData(tr, 'getIT', type);
  const transformed = {
    status: getData(tr, 'getStatus', type),
    label: getData(tr, 'getTitle', type),
    type,
    name: getData(tr, 'getName', type),
    screenshots: get(tr, 'screenshots'),
    extraFiles: get(tr, 'extraFiles'),
    extraInfo: get(tr, 'extraInfo'),
    extraActions: getData(tr, 'getExtraActions', type),
    application: getData(tr, 'getApplication', type),
    showAIFalsePositive: getData(tr, 'getAIIsFalsePositive', type),
    aiAnalysisDescription: getData(tr, 'getAIAnalysisDescription', type),
    ...getData(tr, 'getExtraData', type),
  };
  const transformedChildren = (children || []).map((child, index) =>
    transformTestResultsForTreeView(
      child,
      index,
      [...parentsIds, trIndex],
      typeName
    )
  );
  const idSeparator = '|';
  const key = [...parentsIds, trIndex].join(idSeparator);

  const d = {
    key,
    ...transformed,
  };

  if (isEmpty(transformedChildren)) {
    const contentMessage = getData(tr, 'getContentMessage', type);
    if (isEmpty(contentMessage)) {
      d.leaf = true;
      d.needsHeader = true;
    } else {
      d.children = [
        {
          key: [key, 0].join(idSeparator),
          label: contentMessage,
          leaf: true,
          needsHeader: false,
        },
      ];
    }
  } else {
    d.children = transformedChildren;
  }

  return d;
}

export function getTestResultsForTreeView(
  testResults = [],
  trIndex = 0,
  typeName = 'UrlTestSuite'
) {
  return testResults.map((tr, index) =>
    transformTestResultsForTreeView(tr, index + trIndex, [], typeName)
  );
}

export function getElementForTreeNode({
  currentTestResult,
  openScreenshotModal,
  closeScreenshotModal,
}) {
  const {
    screenshots = [],
    extraFiles = [],
    status,
    label,
    type,
    leaf = false,
    needsHeader = true,
    children = [],
    showAIFalsePositive,
    // aiAnalysisDescription,
  } = currentTestResult;

  // Check if this is a failed TestCaseStep with AI false positive indicator

  // Extract AI analysis description for tooltip
  // console.log(currentTestResult);
  const aiAnalysisDescription = currentTestResult.ai_analysis_description || '';

  return leaf && !needsHeader ? (
    !isEmpty(label) && <div className='content-message'>{label}</div>
  ) : (
    <TestResultsAccordionHeader
      screenshots={screenshots}
      name={label}
      extraActions={getData(currentTestResult, 'getExtraActions', type)}
      extraFiles={extraFiles}
      type={getData(currentTestResult, 'getTypeText', type)}
      status={status}
      openScreenshotModal={openScreenshotModal}
      closeScreenshotModal={closeScreenshotModal}
      showAIFalsePositive={showAIFalsePositive}
      aiAnalysisDescription={aiAnalysisDescription}
    >
      {children}
    </TestResultsAccordionHeader>
  );
}
